<template>
  <div>
    <!-- <el-button class="clear" @click="clickClear">クリア</el-button> -->
    <el-button type="primary" class="calculation" @click="clickCalculation">計算</el-button>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data () {
    return {}
  },
  methods: {
    // clickClear () {
    //   // console.log('SearchDialogFooter.clickClear(S)')
    //   this.$emit('clear')
    //   // console.log(this)
    //   // console.log('SearchDialogFooter.clickClear(E)')
    // },
    clickCalculation () {
      this.$emit('calculation')
    }
  }
}
</script>

<style lang="scss" scoped>
.calculation {
  width: 8em;
}
</style>
